module.exports = __webpack_public_path__ + "static/media/password-success.68156ffc.svg";